import styled from 'styled-components'

import {styledTheme} from '@festi/common/themes'

const Root = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 50%;
  background-color: ${styledTheme.palette.successBack};
  color: ${styledTheme.palette.blue};
`

interface Props {
  count: number
}

export default function CompareDrawerCountBubble({count}: Props) {
  return <Root>{count}</Root>
}
